import React, { useEffect, useState } from 'react';
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Icone } from 'vivace-fluent-motion';
import Avatar from '@componentes/avatar';
import BaseConhecimento from '@containers/BaseConhecimento';
import * as actions from '../../pages/laudo/etapas/material/material.action';
import * as commonActions from '../../app/common/common.action';
import { acessoPermitido } from '../../acessos.seguranca';
import * as acessos from '../../acessos.const.util';
import '../_util/icons/mv-basico/css/mv-basico.old.css';
import './nav.styles.css';
import IntlMessage from '../../helpers/intlMessage';


function NavComponent(props) {

	const [icones, setIcones] = useState([]);

	useEffect(()=>{
		props.icones && setIcones(props.icones);
	}, [props])

  return (
    <React.Fragment>
    <nav className="mv-nav-container">
      <div className="mv-nav-left">
        <div className="nav-titulo">
          <span className="d-none d-md-flex">
          <IntlMessage id="dashboards.general.title" />
          </span>
          <span className="d-flex d-md-none">{props.titulo}</span>
        </div>
        <div className="d-none d-md-flex nav-base-conhecimento">
          <BaseConhecimento />
        </div>
      </div>
      <div className="mv-nav-rigth menu-right d-flex d-lg-none mr-3">
        <UncontrolledDropdown className="dropdown-menu-right mr-1">
          <DropdownToggle className="p-0" color="empty">
            <div className="menu-right">
              <span className="mr-2">{props.usuario}</span>
              <i className="mv-basico-visualizacao_tile"></i>
            </div>
          </DropdownToggle>
          <DropdownMenu className="mt-3" right>
            {icones.map((item, i) => (
              <DropdownItem key={i} onClick={() => item.onClick()}>
                <React.Fragment>
                  {item.name}
                  {item.badge && (
                    <Badge color="info" pill className="ml-1">
                      {item.badge}
                    </Badge>
                  )}
                </React.Fragment>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
      
      <div className="mv-nav-rigth d-none d-lg-flex">
        <div
          className="nav-icones"
          style={{ margin: props.empresa ? '' : '2px' }}
        >
          {icones.map((item, i) => (
            <React.Fragment key={i}>

              <div id={'icone_' + item.id} style={{height: 40}}>
              <Icone
                className="icon-base"
                //iconColor={theme.ComponentColor.Nav.Icon.Color}
                iconColorOnHover={'black'}
                
                id={item.id}
                key={item.id}
                style={{ margin: '9px 18px' }}
                icone={item.icone}
                onClick={item.onClick}
              >
                {item.badge && (
                  <Badge color="info" pill className="custom-badge">
                    {item.badge}
                  </Badge>
                )}
              </Icone>
              </div>
             { item.id && <UncontrolledTooltip placement="bottom" target={'icone_' + item.id}>
                <strong> {item.name}</strong>
              </UncontrolledTooltip>}
            </React.Fragment>
          ))}
        </div>
        <div className="user d-flex">
          <UncontrolledDropdown className="dropdown-menu-right">
            <DropdownToggle className="p-0" color="empty">
              <div className="d-flex name mr-1">
                {props.usuario}
                <span className="avatar-content">
                  <Avatar>{props.usuario}</Avatar>
                </span>
              </div>
            </DropdownToggle>
            <DropdownMenu className="mt-3" right>
              <DropdownItem onClick={() => props.onLogoutClick()}>
              <IntlMessage id="dashboards.general.logout" />
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
    </nav>
      </React.Fragment>
  );
}

NavComponent.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    usuarioAcessos: state.usuario,
    collapsed: state.recebimentoMaterial.collapsedMenu,
    totalMensagens: state.commonReducer.totalMensagens,
    modalMensagens: state.commonReducer.modalMensagens,
  };
};

const mapDispacthToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(NavComponent);



// WEBPACK FOOTER //
// ./src/componentes/navbar/nav.component.js